import moment from 'moment';
import React, { useEffect, useRef } from 'react';
import { 
  FiSearch, 
  FiEye, 
  FiTrash2, 
  FiToggleLeft, 
  FiToggleRight,
  FiCheckCircle,
  FiXCircle,
  FiUser,
  FiTag,
  FiClock,
  FiCalendar,
  FiFileText,
  FiPlus,
  FiRefreshCw,
  FiMoreVertical,
  FiArrowUp,
  FiArrowDown,
  FiTrendingUp,
  FiTrendingDown,
  FiDollarSign,
  FiAward,
  FiUsers
} from "react-icons/fi";
import { 
  MdOutlineSearch, 
  MdOutlineVisibility,
  MdOutlineDelete,
  MdOutlinePerson,
  MdOutlineCategory,
  MdOutlineCalendarToday,
  MdOutlineCheckCircle,
  MdOutlineCancel,
  MdOutlinePending,
  MdOutlineAdd,
  MdOutlineRefresh,
  MdOutlineAttachMoney,
  MdOutlineAccessTime
} from "react-icons/md";
import { RiDeleteBin6Line } from 'react-icons/ri';
import ReactPaginate from 'react-paginate';

const ViewSubTable = ({
  TableName,
  TableHeader,
  TableData,
  showMenu,
  deleteAction,
  handleToggle,
  handleCreateModal,
  keyword,
  setKeyword,
  pageNo,
  viewAction,
  setpageNo,
  size,
  setSize, 
  total, 
  handlePageClick
}) => {
  const ContentActionRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ContentActionRef.current && !ContentActionRef.current.contains(event.target)) {
        showMenu(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMenu]);

  // Status badge component
  const StatusBadge = ({ isDisable }) => {
    if (!isDisable) {
      return (
        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full">
          <FiCheckCircle className="w-3.5 h-3.5 text-emerald-500" />
          Active
        </span>
      );
    }
    return (
      <span className="inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium text-rose-700 bg-rose-50 border border-rose-200 rounded-full">
        <FiXCircle className="w-3.5 h-3.5 text-rose-500" />
        Disabled
      </span>
    );
  };

  return (
    <div className="w-full">
      <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
        {/* Header Section */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 p-4 md:p-5 border-b border-gray-100 bg-gradient-to-r from-gray-50/50 to-white">
          <div className="flex items-center gap-3">
            <div className="p-1.5 bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 rounded-lg">
              <FiUsers className="w-4 h-4 text-[#715EFE]" />
            </div>
            <div>
              <h2 className="text-base font-semibold text-gray-800">{TableName}</h2>
              <p className="text-xs text-gray-400 hidden sm:block">
                {TableData?.length || 0} subscribers
              </p>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-50/80 text-xs font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-100">
                {TableHeader.map((heading, index) => {
                  const headerIcons = {
                    '#': null,
                    'User': FiUser,
                    'Amount': FiDollarSign,
                    'Created Date': FiCalendar,
                    'Expire Date': FiCalendar,
                    'Status': FiCheckCircle,
                    'Action': null
                  };
                  const Icon = headerIcons[heading];
                  return (
                    <th key={index} className="px-3 md:px-4 py-3 whitespace-nowrap">
                      <div className="flex items-center gap-1.5">
                        {Icon && <Icon className="w-3.5 h-3.5 text-gray-400" />}
                        <span>{heading}</span>
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {TableData && TableData.length > 0 ? (
                TableData.map((ele, index) => (
                  <tr key={index} className="hover:bg-gray-50/70 transition-colors duration-150 group">
                    <td className="px-3 md:px-4 py-3">
                      <span className="text-sm font-medium text-gray-400">
                        {index + 1}
                      </span>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                    <div className="flex items-center gap-2.5">
                      <div className="relative w-9 h-9">
                        <img
                          src={
                            ele?.subscribedUser?.profile ||
                            "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?semt=ais_hybrid&w=740&q=80"
                          }
                          alt="User"
                          className="w-9 h-9 rounded-full object-cover border-2 border-gray-200"
                          onError={(e) => {
                            e.currentTarget.style.display = "none";

                            const fallback = e.currentTarget.nextElementSibling;
                            if (fallback) {
                              fallback.style.display = "flex";
                            }
                          }}
                        />

                        <div
                          className="w-9 h-9 rounded-full bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 items-center justify-center"
                          style={{ display: "none" }}
                        >
                          <span className="text-xs font-bold text-[#715EFE]">
                            {ele?.subscribedUser?.fullName?.charAt(0)?.toUpperCase() || "U"}
                          </span>
                        </div>
                      </div>

                      <span className="text-sm font-medium text-gray-800 truncate max-w-[120px]">
                        {ele?.subscribedUser?.fullName || "-"}
                      </span>
                    </div>

                      {/* <div className="flex items-center gap-2.5">
                        <img
                          src={ele?.subscribedUser?.profile || "https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg?semt=ais_hybrid&w=740&q=80"}
                          alt="User"
                          className="w-9 h-9 rounded-full object-cover border-2 border-gray-200"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.parentElement.innerHTML = `<div class="w-9 h-9 rounded-full bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 flex items-center justify-center"><span class="text-xs font-bold text-[#715EFE]">${ele?.subscribedUser?.fullName?.charAt(0)?.toUpperCase() || 'U'}</span></div>`;
                          }}
                        />
                        <span className="text-sm font-medium text-gray-800 truncate max-w-[120px]">
                          {"ele?.subscribedUser?.fullName" || '-'}
                        </span>
                      </div> */}
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <span className="text-sm font-semibold text-emerald-600">
                        ${ele?.amount?.toFixed(2) || '0.00'}
                      </span>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex flex-col">
                        <span className="text-sm text-gray-700 whitespace-nowrap">
                          {ele?.createdAt ? moment(ele.createdAt).format('MMM D, YYYY') : '-'}
                        </span>
                        {ele?.createdAt && (
                          <span className="text-xs text-gray-400">
                            {moment(ele.createdAt).format('h:mm A')}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex flex-col">
                        <span className="text-sm text-gray-700 whitespace-nowrap">
                          {ele?.expireAt ? moment(ele.expireAt).format('MMM D, YYYY') : '-'}
                        </span>
                        {ele?.expireAt && (
                          <span className="text-xs text-gray-400">
                            {moment(ele.expireAt).format('h:mm A')}
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <StatusBadge isDisable={ele?.isDisable} />
                    </td>
                    <td className="px-3 md:px-4 py-3">
                      <div className="flex items-center gap-1">
                        <button
                          className={`p-1.5 rounded-lg transition-all duration-200 ${
                            !ele?.isDisable
                              ? 'text-emerald-400 hover:text-emerald-600 hover:bg-emerald-50'
                              : 'text-amber-400 hover:text-amber-600 hover:bg-amber-50'
                          }`}
                          onClick={() => deleteAction(ele)}
                          title={ele?.isDisable ? 'Activate' : 'Deactivate'}
                        >
                          {ele?.isDisable ? (
                          <FiToggleLeft className="w-4 h-4" />
                          ) : (
                            <FiToggleRight className="w-4 h-4" />
                          )}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={TableHeader.length} className="px-4 py-12 text-center">
                    <div className="flex flex-col items-center gap-3">
                      <div className="p-4 bg-gray-50 rounded-full">
                        <FiUsers className="w-10 h-10 text-gray-300" />
                      </div>
                      <p className="text-sm font-medium text-gray-500">No subscribers found</p>
                      <p className="text-xs text-gray-400">No subscription records available</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Mobile View for Small Screens */}
        <div className="md:hidden divide-y divide-gray-100">
          {TableData && TableData.length > 0 ? (
            TableData.map((ele, index) => (
              <div key={index} className="p-4 hover:bg-gray-50/70 transition-colors duration-150">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-medium text-gray-400">
                      #{index + 1}
                    </span>
                    <StatusBadge isDisable={ele?.isDisable} />
                  </div>
                  <button
                    className={`p-1.5 rounded-lg transition-all duration-200 ${
                      ele?.isDisable
                        ? 'text-emerald-400 hover:text-emerald-600 hover:bg-emerald-50'
                        : 'text-amber-400 hover:text-amber-600 hover:bg-amber-50'
                    }`}
                    onClick={() => deleteAction(ele)}
                  >
                    {!ele?.isDisable ? (
                      <FiToggleLeft className="w-4 h-4" />
                    ) : (
                      <FiToggleRight className="w-4 h-4" />
                    )}
                  </button>
                </div>
                <div className="space-y-2">
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500">User</span>
                    <span className="text-sm font-medium text-gray-800">
                      {ele?.subscribedUser?.fullName || '-'}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500">Amount</span>
                    <span className="text-sm font-semibold text-emerald-600">
                      ${ele?.amount?.toFixed(2) || '0.00'}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500">Created</span>
                    <span className="text-sm text-gray-700">
                      {ele?.createdAt ? moment(ele.createdAt).format('MMM D, YYYY') : '-'}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500">Expires</span>
                    <span className="text-sm text-gray-700">
                      {ele?.expireAt ? moment(ele.expireAt).format('MMM D, YYYY') : '-'}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="p-8 text-center">
              <div className="flex flex-col items-center gap-2">
                <FiUsers className="w-10 h-10 text-gray-300" />
                <p className="text-sm text-gray-500">No subscribers found</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewSubTable;